import { Reducer } from 'redux';
import {
	BOOKS_BUMP_RELOAD,
	BOOKS_SET_CREATING,
	BOOKS_SET_HOST,
	BOOKS_SET_REGENERATING,
	BOOKS_SET_SETTINGS,
	IBooksState,
	TBooksActions,
} from './types';

const initialState: IBooksState = {
	creating: {},
	regenerating: {},
	reloadKey: {},
	settings: {},
	bookHost: null,
	bookHostFailed: false,
};

export const booksReducer: Reducer<IBooksState, TBooksActions> = (
	state = initialState,
	action
) => {
	switch (action.type) {
		case BOOKS_SET_CREATING:
			return {
				...state,
				creating: { ...state.creating, [action.audioId]: action.creating },
			};

		case BOOKS_SET_REGENERATING:
			return {
				...state,
				regenerating: { ...state.regenerating, [action.bookId]: action.regenerating },
			};

		case BOOKS_BUMP_RELOAD:
			return {
				...state,
				reloadKey: { ...state.reloadKey, [action.bookId]: (state.reloadKey[action.bookId] || 0) + 1 },
			};

		case BOOKS_SET_SETTINGS:
			return {
				...state,
				settings: { ...state.settings, [action.bookId]: action.settings },
			};

		case BOOKS_SET_HOST:
			return {
				...state,
				bookHost: action.bookHost,
				bookHostFailed: action.failed,
			};

		default:
			return state;
	}
};
